import { ReportProblem } from '@mui/icons-material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Badge as BadgeMui, Box, IconButton, styled } from '@mui/material';
import { useCommunications } from 'apps/wrapper/src/hooks/use-communications';
import { useEventBus } from 'apps/wrapper/src/hooks/use-event-bus';
import { PatientCaseWithTimetoken } from 'apps/wrapper/src/hooks/use-leads-management/use-leads-management';
import { MilaCase } from 'apps/wrapper/src/services/mila-service/types';
import moment from 'moment-timezone';
import { FC, useCallback } from 'react';
import { ReactComponent as RwAiIcon } from '../../../../assets/rw-ai-icon.svg';
import {
  TitleStatusWrapper,
  TitleText,
  TitleTextWrapper
} from './managed-commnication/shared/title/managed-comm-card-title.styles';

interface CommunicationAiCardProps {
  communication: PatientCaseWithTimetoken;
}

const Row = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  alignItems: 'flex-end',
  paddingLeft: '20%'
});

export const CardWrapper = styled(Box)({
  border: '1px solid #D9D9D9',
  background: '#FCFCFC',
  borderRadius: 8,
  color: '#2C3542',
  display: 'flex',
  padding: 12,
  flexDirection: 'column',
  width: '294px'
});

export const TitleStatusText = styled(Box)({
  fontWeight: 400,
  fontSize: '12px',
  color: '#333333'
});

export const Badge = styled(BadgeMui)({
  marginRight: 4,
  backgroundColor: '#FFF0CA',
  borderRadius: 100,
  width: 24,
  height: 16,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#6B4904',
  '.MuiSvgIcon-root': {
    width: 10,
    height: 10
  }
});

const getWarningMessage = (outcome: string, communicationChannel: MilaCase['communicationChannel']) => {
  if (String(outcome).toLowerCase().includes('rescheduling')) {
    return 'Callback Requested';
  }

  if (String(outcome).toLowerCase().includes('inbound') && communicationChannel === 'VOICE') {
    return 'Callback Requested';
  }

  return 'Requires Attention';
};

export const CommunicationAiCard: FC<CommunicationAiCardProps> = (props) => {
  const { publish } = useEventBus();
  const { patientId } = useCommunications();
  const { communication } = props;

  const handleExpandClick = useCallback(async () => {
    publish({
      messageType: 'milaDialog',
      data: {
        type: 'view-case',
        caseId: communication.caseId,
        patientId: patientId || undefined
      }
    });
  }, [communication]);

  return (
    <Row>
      <CardWrapper>
        <Box>
          <TitleTextWrapper>
            <TitleText>{communication.caseOutcome}</TitleText>
            <IconButton sx={{ width: '25px', height: '25px' }} onClick={handleExpandClick}>
              <KeyboardArrowDownIcon sx={{ fontSize: '1.2rem' }} />
            </IconButton>
          </TitleTextWrapper>
          {communication.status && ['CRITICAL', 'CLOSED'].includes(communication.status) && (
            <TitleStatusWrapper>
              <Badge>
                <ReportProblem />
              </Badge>
              <TitleStatusText>
                {getWarningMessage(communication.caseOutcome, communication.communicationChannel)}
              </TitleStatusText>
            </TitleStatusWrapper>
          )}
        </Box>
      </CardWrapper>
      <Box
        sx={{
          color: '#2C3542',
          fontSize: '12px',
          fontWeight: 500,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          margin: '5px 0px 0 auto'
        }}
      >
        RW AI <RwAiIcon style={{ width: '12px', height: '12px', marginLeft: '3px' }} />
        <Box sx={{ padding: '0 5px', color: '#C8C8C8' }}>|</Box>
        <Box>{moment(communication.timetoken).format('h:mm A')}</Box>
      </Box>
    </Row>
  );
};
